import {observable, action} from 'mobx'
import {handleSearchAndPage, setStore, ValueObjToObj,clearForm} from "../../../../utils/Utils";
import {json} from "../../../../utils/ajax";
import {runInAction} from "mobx/lib/mobx";
import moment from "moment/moment";

class answerQuestionStore {
    @observable loading  //答疑报表loading
    @observable list  //答疑报表列表
    @observable pagination  //答疑报表分页
    @observable carseries  //车系下拉框值
    @observable mainGroupCodeList //主组号
    @observable groupCode //分组号
    @observable selectList //下拉框数据
    @observable modelStatus
    @observable modalStatus
    @observable modalList
    @observable modalPagination
    @observable modalLoading
    @observable questionTypeName  //当前选择的问题类型
    @observable questionTypeList  //问题类型
    @observable timeModal //时间导出

    constructor() {
        this.modalLoading=false
        this.loading = false
        this.list = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal:()=>{}
        }
        this.modalPagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 10,
            showTotal:()=>{}
        }
        this.carseries=[]
        this.searchField = {
            carseriesCode:'',
            subject:'',
            type:'',
            mainGroupCode:'',
            groupCode:'',
            postLogName:'',
            postTime:'',
            assess:'',
            replyStatus:'',
            serviceCode:'',
        }
        this.mainGroupCodeList=[]
        this.groupCode=[]
        this.selectList=[]
        this.modelStatus=false
        this.modalStatus=false
        this.modalList=[]
        this.questionTypeList = []
        this.timeModal = false
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**页面初始化*/
    @action
    initPage = async (page) => {
        this.loading = true
        let seacrhFild = {
            ...this.searchField,
            carseriesCode:this.searchField.carseriesCode ? this.searchField.carseriesCode :'',
            subject:this.searchField.subject ? this.searchField.subject :'',
            type:this.searchField.type ? this.searchField.type :'',
            mainGroupCode:this.searchField.mainGroupCode ? this.searchField.mainGroupCode.split('/')[1] :'',
            groupCode:this.searchField.groupCode ? this.searchField.groupCode :'',
            postLogName:this.searchField.postLogName ? this.searchField.postLogName :'',
            postTime:this.searchField.postTime ? moment(this.searchField.postTime).format("YYYY-MM-DD") :'',
            assess:this.searchField.assess ? this.searchField.assess :'',
            replyStatus:this.searchField.replyStatus ? this.searchField.replyStatus :'',
            serviceCode:this.searchField.serviceCode ? this.searchField.serviceCode :'',
        }
        let search = handleSearchAndPage(page, this.pagination, seacrhFild)
        let res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerReport/getAnswerReportPage:search`,search)
        runInAction(() => {
            this.list = res.content ?  res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
            this.loading = false
        })
    }

    /***问题类型**/
    @action
    getQuestionType = async () => {
        let res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/getOneRoot`, {name: '问题类型/'})
        runInAction(()=> {
            this.questionTypeList = Array.isArray(res.children) ? res.children : []
        })
    }

    /**请求车系**/
    @action
    carSeries = async (e) => {
        this.questionTypeName = e ? e : ''
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/moduleNameQueryCarSeriesTable/${e}`)
        runInAction(() => {
            this.carseries = Array.isArray(res) ? res : []
        })
    }

    /***搜索框下拉数据 ***/
    @action
    initAddSelect = async () => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/selectData`)
        runInAction(() => {
            this.selectList = Array.isArray(res) ? res : []
        })
    }

    /****根据车系选择主组号***/
    @action
    getMainGroupCode=async(value)=>{
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/directory?carseriesCode=${value}`)
        runInAction(()=>{
            this.mainGroupCodeList = Array.isArray(res) ? res : []
        })
    }

    /****根据主组号选择分组号***/
    @action
    getGroupCode=async(carseriesCode,values)=>{
        const id = values.split('/')[0]
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/queryLvThreeCatalogs/carseriesCode?carseriesCode=${carseriesCode}&lv2Id=${id}`)
        runInAction(()=>{
            this.groupCode = Array.isArray(res) ? res : []
        })
    }

    /***搜索表单、列表新增绑值**/
    @action
    onFormField = (changedFields,fields) => {
        const change = ValueObjToObj(changedFields)
        this[fields] = {...this[fields], ...change}
    }


    /**主页面搜索重置**/
    @action
    handleReset = () => {
        this.searchField =clearForm(this.searchField)
        this.questionTypeName = ''
        this.mainGroupCodeList=[]
        this.groupCode=[]
        this.initPage(this.pagination.current)
    }

    @action
    initModalPage =async (page) =>{
        runInAction(()=>{
            this.modalLoading=true
        })
        let search = handleSearchAndPage(page, this.modalPagination, {})
        let res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerReport/census`,search)
        runInAction(()=>{
            this.modalList = res.content ?  res.content : []
            this.modalPagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
            this.modalLoading=false
        })

    }

    @action
    census=()=>{
            this.modalStatus=true
    }

}

export default new answerQuestionStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/AnswerPlatform/AnswerQuestion/store.js